import { InfiniteData, useInfiniteQuery } from "@tanstack/react-query";
import fetcher from "@adora/shared/utils/fetch";
import { RelativeUrl } from "@adora/shared/utils/environment";
import { commonQueryOptions, queryKeys } from "../utils/tanstack-query-helpers";
import type { EvalQueryParams, EvalRequestParams, EvalResponse } from "../types/creative-eval";

type CreativeEvalQueryKey = ReturnType<typeof queryKeys.creativeEval>;

export function buildEvalRequestUrl(params: EvalRequestParams): string {
  const searchParams = new URLSearchParams(
    Object.entries(params)
      .filter(([, v]) => v !== undefined && v !== null && v !== "")
      .map(([k, v]) => [k, String(v)])
  ).toString();

  return `${RelativeUrl}/creative-eval/evals?${searchParams}`;
}

export function useCreativeEvalQuery(
  params: EvalQueryParams | null,
  initialData?: InfiniteData<EvalResponse, string | null>
) {
  return useInfiniteQuery<
    EvalResponse,
    Error,
    InfiniteData<EvalResponse, string | null>,
    CreativeEvalQueryKey,
    string | null
  >({
    queryKey: queryKeys.creativeEval(params),
    queryFn: ({ pageParam }) => {
      if (!params) throw new Error("Creative evaluation query params are required.");
      return fetcher(buildEvalRequestUrl({ ...params, page_token: pageParam }));
    },
    initialPageParam: null,
    getNextPageParam: (lastPage) => lastPage.next_page_token ?? undefined,
    enabled: params !== null,
    ...(initialData ? { initialData } : {}),
    ...commonQueryOptions.stable
  });
}
